export const FETCH_RVU_REPORT = 'FETCH_RVU_REPORT'
export const FETCH_RVU_REPORT_SUCCESS = 'FETCH_RVU_REPORT_SUCCESS'
export const FETCH_RVU_REPORT_ERROR = 'FETCH_RVU_REPORT_ERROR'
